import RestClient from './../../service/rest-client';
import {Signal} from 'signals';
import moment from 'moment'
import utils from './../../component/utils/utils'
import numeral from 'numeral';

class Service {

    event = {
        onFetchSignUpStatsPerDayTableData: new Signal(),
        onFetchSignUpStatsPerDayChartData: new Signal(),
        onFetchSignUpsForPeriodOfDaysByCountry: new Signal(),
        onFetchSignUpsStatsBySource: new Signal()
    };

    fetchSignUpStatsPerDay(intervalDates, typeOfRequest) {
        intervalDates = intervalDates || 1;
        typeOfRequest = typeOfRequest || 'table';

       RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

          var urlRequestTemplate = "/reporting/signupstats/perday?" + queryParams.join("&");

           return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
               var page = data.page_number;
               var pageSize = data.page_size,
                   offset = (page - 1) * pageSize;
               var pagingMetadata = {
                   page: data.page_number,
                   startIndex: offset + 1,
                   endIndex: offset + pageSize,
                   totalCount: data.total_count,
                   pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
               };
                data.pagingMetadata = pagingMetadata;

               if (typeOfRequest === 'table') {
                   data.results = this.parseRequestDataForSignUpStatistics(data.results);
                   this.event.onFetchSignUpStatsPerDayTableData.dispatch(data);
               } else if (typeOfRequest === 'chart') {
                   data.chartData = this.parseRequestDataForChartSignUpStatistics(data.results);
                   this.event.onFetchSignUpStatsPerDayChartData.dispatch(data);
               }
           }).catch((error) => {
               console.log("Error: " + error);
           });
    }

    parseRequestDataForSignUpStatistics(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.accountCreationDate =  moment(dataItem.date).format("L");
            parsedObject.countSignUpPerDate = dataItem.countItems;

            return parsedObject;
        });
        return parsedArray;
    }

    // Sign Ups By Country
    fetchSignUpStatsByCountry(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/signupstats/bycountry?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSignUpHistogramByCountry(data.results);
            this.event.onFetchSignUpsForPeriodOfDaysByCountry.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSignUpHistogramByCountry(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.countryName);
            chartData.seriesDataList.push(dataItem.countItems);
        });

        return chartData;
    }
    // Sign Ups By Source
    fetchSignUpStatsBySource(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/signupstats/bysource?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.histogramChartData = this.parseRequestDataSignUpHistogramSource(data.results);
            this.event.onFetchSignUpsStatsBySource.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSignUpHistogramSource(resultData) {
        var histogramChartData = {
            categoryList : [],
            seriesDataList: []
        };
        resultData.forEach(function(dataItem) {
            if (dataItem.utmSource != null) {
                histogramChartData.categoryList.push((dataItem.utmSource).replace(/first:|last:/gi, ''));
                histogramChartData.seriesDataList.push(dataItem.countItems);
            }
        });

        return histogramChartData;
    }

    fetchSignUpSeriesWithPackageAndShipment(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/signupstats/packageshipmentseries?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataForChartSignUpStatistics(data.results[0]);
            this.event.onFetchSignUpStatsPerDayChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataForChartSignUpStatistics(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
            seriesDataList2: [],
            seriesDataList3: [],
            seriesSignupsWithPackageWithinTwoWeeks: [],
            seriesSignupsWithShipmentWithinFourWeeks: [],
        };

        resultData.series1.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.date).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.countItems);
        });

        resultData.series2.forEach(function(dataItem) {
            chartData.seriesDataList2.push(dataItem.countItems);
        });

        resultData.series3.forEach(function(dataItem) {
            chartData.seriesDataList3.push(dataItem.countItems);
        });

        resultData.seriesSignupsWithPackageWithinTwoWeeks.forEach(function(dataItem) {
            chartData.seriesSignupsWithPackageWithinTwoWeeks.push(dataItem.percentageSignupsWithPackageWithinTwoWeeks);
        });

        resultData.seriesSignupsWithShipmentWithinFourWeeks.forEach(function(dataItem) {
            chartData.seriesSignupsWithShipmentWithinFourWeeks.push(dataItem.percentageSignupsWithShipmentWithinTwoMonths);
        });

        return chartData;
    }

}

export default new Service();